export const siteLogo = {
    logo: "assets/images/cnf-logo1.png", // Add your site logo here
    alt: "Curves Fitness" // Add your site name here
    };
    export const socialLink = {
    facebook: "https://www.facebook.com/people/Curves-Fitness/100054547625464/?mibextid=LQQJ4d",
    whatsapp: "https://call.whatsapp.com/voice/DxQipVjmQtNCSLRepXnP4X",
    };